import React from 'react'
import LoginForm from '../../components/Auth/LoginForm/LoginForm'

const LoginPage = () => {
  return <LoginForm />
}

export default LoginPage
